import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SAVED_SEARCH_RULE_EDITOR_CLASS_NAME = 'SavedSearchRuleEditor';
export const SAVED_SEARCH_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type SavedSearchRuleEditorClassSlot =
	(typeof SAVED_SEARCH_RULE_EDITOR_CLASS_SLOTS)[number];

export interface SavedSearchRuleEditorClasses {
	root: string;
}

export type SavedSearchRuleEditorClassKey = keyof SavedSearchRuleEditorClasses;

export const getSavedSearchRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(SAVED_SEARCH_RULE_EDITOR_CLASS_NAME, slot);

export const savedSearchRuleEditorClasses: SavedSearchRuleEditorClasses =
	generateUtilityClasses(SAVED_SEARCH_RULE_EDITOR_CLASS_NAME, ['root']);

export default savedSearchRuleEditorClasses;
